(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
class InfiniteCarousel {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.container = this.section.querySelector('.css-carousel-container');
    this.track = this.container.querySelector('.css-carousel-track');
    this.realSlides = Array.from(this.track.children);
    
    this.slidesPerView = parseInt(this.section.style.getPropertyValue('--slides-per-view'), 10) || 3;
    
    // Only initialize the infinite loop if there are more slides than can be viewed at once.
    if (this.realSlides.length <= this.slidesPerView) return;
    
    this.autoplay = this.section.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.section.dataset.autoplaySpeed, 10);
    this.autoplayInterval = null;
    this.isTransitioning = false;

    this._setupClones();
    this.currentIndex = this.clonesPerSide;
    this._bindEvents();
    this._setInitialPosition();
  }

  _setupClones() {
    this.clonesPerSide = this.slidesPerView;

    const firstClones = this.realSlides.slice(0, this.clonesPerSide).map(slide => slide.cloneNode(true));
    const lastClones = this.realSlides.slice(-this.clonesPerSide).map(slide => slide.cloneNode(true));

    this.track.append(...firstClones);
    this.track.prepend(...lastClones);
    
    this.allSlides = Array.from(this.track.children);
  }

  _setInitialPosition() {
    this.track.style.transition = 'none';
    this._slideToCurrent();
    
    setTimeout(() => {
      this.track.style.transition = 'transform 0.5s ease';
    }, 50);
  }

  _bindEvents() {
    const prevButton = this.container.querySelector('.carousel-button.prev');
    const nextButton = this.container.querySelector('.carousel-button.next');
    
    prevButton.addEventListener('click', () => this._handlePrev());
    nextButton.addEventListener('click', () => this._handleNext());
    this.track.addEventListener('transitionend', () => this._handleTransitionEnd());
    
    if (this.autoplay) {
      this.container.addEventListener('mouseenter', () => this._stopAutoplay());
      this.container.addEventListener('mouseleave', () => this._startAutoplay());
      this._startAutoplay();
    }
  }

  _slideToCurrent() {
    const slideWidth = this.realSlides[0].offsetWidth;
    this.track.style.transform = `translateX(-${this.currentIndex * slideWidth}px)`;
  }

  _handleNext() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    this.currentIndex++;
    this._slideToCurrent();
  }

  _handlePrev() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    this.currentIndex--;
    this._slideToCurrent();
  }

  _handleTransitionEnd() {
    this.isTransitioning = false;
    
    if (this.currentIndex >= this.realSlides.length + this.clonesPerSide) {
      this.currentIndex = this.clonesPerSide;
      this.track.style.transition = 'none';
      this._slideToCurrent();
      setTimeout(() => { this.track.style.transition = 'transform 0.5s ease'; }, 50);
    }
    
    if (this.currentIndex < this.clonesPerSide) {
      this.currentIndex = this.realSlides.length + this.clonesPerSide - 1;
      this.track.style.transition = 'none';
      this._slideToCurrent();
      setTimeout(() => { this.track.style.transition = 'transform 0.5s ease'; }, 50);
    }
  }
  
  _startAutoplay() {
    if (this.autoplayInterval) clearInterval(this.autoplayInterval);
    this.autoplayInterval = setInterval(() => this._handleNext(), this.autoplaySpeed);
  }

  _stopAutoplay() {
    clearInterval(this.autoplayInterval);
  }
}

const carouselInstances = {};

function initializeCarousel(sectionId) {
  const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (sectionElement) {
    if (carouselInstances[sectionId]) {
      carouselInstances[sectionId]._stopAutoplay();
    }
    carouselInstances[sectionId] = new InfiniteCarousel(sectionElement);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.css-carousel-section').forEach(section => {
    initializeCarousel(section.dataset.sectionId);
  });
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initializeCarousel(event.detail.sectionId);
  });
  document.addEventListener('shopify:section:reorder', () => {
     document.querySelectorAll('.css-carousel-section').forEach(section => {
       initializeCarousel(section.dataset.sectionId);
     });
  });
}

  } catch(e) { console.error(e); }
})();
})();
